import {
  Cartesian3,
  Cesium3DTileset,
  Cesium3DTileStyle,
  CustomShader,
  HeadingPitchRoll,
  Ion,
  IonImageryProvider,
  Math,
  SkyAtmosphere,
  Transforms,
  Viewer,
  ImageryLayer,
  Color,
} from "cesium";
import "cesium/Build/Cesium/Widgets/widgets.css";
import { useEffect, useState } from "react";

// The URL on your server where CesiumJS's static files are hosted.
window.CESIUM_BASE_URL = "/";

export default function Home() {
  Ion.defaultAccessToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1MzExNWEzNS04MmU4LTRlMGMtYTRmNC1iZmFiNjExZGQ1YjUiLCJpZCI6MjUyMTgyLCJpYXQiOjE3MzA0NTE1MDF9.oHMa_wTJHC0C9ICBMttoqKM8E58pTi5-KNWuODPZH_o";

  const [viewer, setViewer] = useState();
  const [maskLayer, setMaskLayer] = useState();

  async function initializeMap() {
    // Initialize the Cesium Viewer in the HTML element with the `cesiumContainer` ID.
    const viewer = new Viewer("cesiumContainer", {
      baseLayerPicker: false,
      sceneModePicker: false,
      skyAtmosphere: new SkyAtmosphere(),
      infoBox: false,
      creditDisplay: false,
    });
    viewer.imageryLayers.removeAll();
    setViewer(() => viewer);

    try {
      const tileset = await Cesium3DTileset.fromIonAssetId(2275207);
      tileset.style = new Cesium3DTileStyle({
        color: {
          conditions: [
            ['true', 'color("white", 0.8)']
          ],
        },
      });
      viewer.scene.primitives.add(tileset);
      viewer.scene.screenSpaceCameraController.minimumZoomDistance = 500;

      await addMaskLayer(viewer);

      // tileset.tileVisible.addEventListener((tile) => {
      //   // Access the content of the tile
      //   const content = tile.content;
      //   // console.log('tile', tile);
      //   // console.log('tile-content', content)
      // });

      // // console.log("tileset", tileset);

      // await viewer.zoomTo(imageryLayer);
    } catch (error) {
      console.log("threw an error", error);
    }

    // Hide cesium timeline
    viewer.animation.container.style.visibility = "hidden";
    viewer.timeline.container.style.visibility = "hidden";
    viewer.forceResize();

    // Pan to Ghana
    // viewer.geocoder.viewModel.searchText = "Ghana";
    // viewer.geocoder.viewModel.search();
    // viewer.resize = "14";
  }

  useEffect(() => {
    initializeMap();
  }, []);

  async function toggleMaskLayer() {
    if (viewer.imageryLayers.length) {
      viewer.imageryLayers.removeAll();
      setMaskLayer(null);
    }
    else 
      await addMaskLayer(viewer);
  }

  async function addMaskLayer(viewer) {
    const layer = viewer.imageryLayers.addImageryProvider(
      await IonImageryProvider.fromAssetId(3279599)
    );
    layer.alpha = 0.05;
    layer.brightness = 20.0;
    layer.contrast = 2.3;
    layer.saturation = 10.0;
    layer.hue = 2.5;
    layer.gamma = 2.92;
    await viewer.zoomTo(layer);
    setMaskLayer(layer);
  }
  

  return (
    <main>
      <div id="cesiumContainer" style={{ height: "100vh" }}></div>
      <button style={{"zIndex": 100, position: "absolute", top: 20, left: 20}} onClick={() => toggleMaskLayer()}>Toggle Mine Mask</button>
    </main>
  );
}
